import React from 'react';
import './NotificationSkeleton.css';

function NotificationSkeleton() {
  return (
    <div className="notification-skeleton-list">
      {Array.from({ length: 10 }).map((_, i) => (
        <div key={i} className="notification-skeleton-card">
          <div className="notification-skeleton-avatar" />

          <div className="notification-skeleton-content">
            <div className="notification-skeleton-line short" />
            <div className="notification-skeleton-line long" />
            <div className="notification-skeleton-line time" />
          </div>

          <div className="notification-skeleton-delete" />
        </div>
      ))}
    </div>
  );
}

export default NotificationSkeleton;
